import { MainLayout } from "@components/layouts/MainLayout";
import { Ticket } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { PurchaseReferral } from "@components/players/game-pass/PurchaseReferral";
import { Funnelling } from "@components/players/game-pass/Funnelling";
import { useState } from "react";
import { useApiDataWithDateRange } from "@hooks/useApiDataWithDateRange";
import { addDays } from "date-fns";
import type { DateRange } from "react-day-picker";
import { DatePickerWithRange } from "@components/ui/date-range-picker";
import { Separator } from "@components/ui/separator";

export default function GamePass() {
  const [dateRange, setDateRange] = useState<DateRange | undefined>({
    from: addDays(new Date(), -30),
    to: new Date(),
  });

  const [gamepassStats, loading, error] = useApiDataWithDateRange(
    "/api/superone/player-gamepass-stats",
    dateRange,
    {
      transform: (res: any) => {
        if (Array.isArray(res)) return res;
        if (res && typeof res === "object") {
          if (Array.isArray(res.gamepassStats)) return res.gamepassStats;
          if (Array.isArray(res.players)) return res.players;
          if (Array.isArray(res.data)) return res.data;
        }
        return [];
      },
    }
  );

  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<Ticket className="h-6 w-6 text-blue-600" />}
            title="Game Pass"
            subtitle="Game pass purchases and referral data."
          />
          <div className="mt-4 md:mt-0">
            <DatePickerWithRange
              defaultRange={dateRange}
              onDateChange={setDateRange}
            />
          </div>
        </div>
        <Separator className="mb-12" />
        <div className="space-y-8">
          <div className="pt-4 pb-4">
            <PurchaseReferral
              data={gamepassStats}
              loading={loading}
              error={error}
              startDate={dateRange?.from}
              endDate={dateRange?.to}
            />
          </div>
          {/* <div className="pt-4 pb-4">
            <Funnelling
              data={gamepassStats}
              loading={loading}
              error={error}
              startDate={dateRange?.from}
              endDate={dateRange?.to}
            />
          </div> */}
        </div>
      </div>
    </MainLayout>
  );
}
